<script>
import Vue from 'vue'

import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
 import {
  required
} from 'vuelidate/lib/validators' 

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, PageHeader },
  page: {
    title: 'Lista',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {  
      exitoso:null,   
      title: 'Lista',
      data: null,
      procesando: false,
      valoresForm:{
        arrayValores:[],
        nombreVal:'',
        valorVal:''
      },
      form: {
        
        nombre: '', 
        nombreVal:'',
        valor:''  
      },
      
      items: [
        {
          text: 'REPODECAM',
          href: '/',
        },
        {
          text: 'listas',
          href: '/listas/listas',
        },
        {
          text: 'Nuevo',
          active: true,
        },
      ],
       submitted: false,
    }
  },
  validations: {
    form: {
      nombre: { required }
    },
},
  computed:{
  
  },
  mounted(){
          this.exitoso = this.$route.params.exito;
  },
   methods:{
     guardar: function(events){
       var valorA={nombreVal:this.valoresForm.nombreVal, valorVal:this.valoresForm.valorVal};
       this.valoresForm.arrayValores.push(valorA);
        
        this.valoresForm.nombreVal='';
        this.valoresForm.valorVal='';
     },
     deleteTask: function (index) {
        this.valoresForm.arrayValores.splice(index, 1);
      },
    handleSubmit(e) {
      this.submitted = true
       
      if(!this.$v.$invalid){
        if(this.valoresForm.arrayValores.length>0){
          
          return axios
              .post(appConfig.recursosApi.lista , { Nombre: this.form.nombre })
              .then((response) => {
                for(var i=0;i<this.valoresForm.arrayValores.length;i++){
              axios
                  .post(appConfig.recursosApi.valorLista,{Nombre:this.valoresForm.arrayValores[i].nombreVal,Valor:this.valoresForm.arrayValores[i].valorVal,IdLista:response.data.id})
                  .then((response)=>{
                    this.$router.push('/listas/listas/true') ;
                  }).catch(()=>  {
                    // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                      this.$router.push('/500') ;
                  });
          }
              }).catch(()=>  {
                Vue.swal({
          type: 'error',
          title: 'Oops...',
          text: 'Ocurrio un error al intentar guardar los datos.',
          confirmButtonClass: 'btn btn-confirm mt-2',
          
        })
              });
        }

      }
      this.$v.$touch()
    },
    
     
  }
}


</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
 <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title m-t-0">Nueva Lista</h4>
          <p
            class="text-muted font-14 m-b-20"
          >Ingrese la información la lista ha dar de alta.</p>

          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label for="name">
                Lista:
                <span class="text-danger">*</span>
              </label>
              <input
                id="nombre"
                v-model="form.nombre"
                name="username"
                class="form-control"
                :class="{ 'is-invalid': submitted && $v.form.nombre.$error }"
                type="text"
                placeholder=""
              />
              <div
                class="invalid-feedback"
              >Debe ingresar el nombre de la lista que desea dar de alta.</div>
            </div>
            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit">Guardar</button>
              <router-link class="btn btn-secondary m-l-5 ml-1" to="/listas/listas"> Cancelar</router-link>
            </div>
          </form>
        </div>
        <!-- end card-box -->
      </div>
 </div>

 <div class="row">
    <div class="col-lg-6">
        <div class="card-box">
          <div class="col-lg-3">
            <b-button  v-b-modal.modal-agregar-valor variant="btn btn-success btn-xs waves-effect mb-2 waves-light" >
                  <i class="fe-file-plus"></i> Agregar
            </b-button>
          </div>

          <!--Inicio del Modal-->
          <b-modal
          
            id="modal-agregar-valor" 
            title="Agregar Valor de Lista" 
            data-animation="blur"
            ok-title = "Agregar"
            cancel-title = "Cancelar"

            title-class="font-18"
            @ok="guardar"
            >
              <p
            class="text-muted font-14 m-b-20"
          >Ingrese el nuevo Valor</p>

          <form >
            <div class="form-group">
             
              <label>Nombre de Valor</label>
              <input
                id="nombreVal"
                v-model="valoresForm.nombreVal"
                class="form-control"
                type="text"
                placeholder=""
              />
              <label>Valor</label>
              <input
                id="valorVal"
                v-model="valoresForm.valorVal"
                class="form-control"
                type="text"
                placeholder=""
              />
              
              <br/>
              
            </div>
       
          </form>
          <div slot="modal-ok">
            <b-spinner v-show="procesando" small></b-spinner> Guardar
                    
          </div>

            </b-modal>

          <!--Fin del modal-->
         <br/>
          <table class="table text-center">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Valor</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(val, index) in valoresForm.arrayValores" :key="val.id">
                <td v-text="val.nombreVal"></td>
                <td v-text="val.valorVal"></td>
                <td><button class="btn btn-danger btn-xs waves-effect waves-light" @click="deleteTask(index)"><i class="fe-x-circle"></i> Quitar</button></td>
              </tr>
            </tbody>

          </table>
        </div>
    </div>
 </div>
  </Layout>
</template>
